var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.50016H12.3458C12.0042 1.5335 11.0875 0.833496 10 0.833496C8.9125 0.833496 7.99583 1.5335 7.65417 2.50016H4.16667C3.24583 2.50016 2.5 3.246 2.5 4.16683V15.8335C2.5 16.7543 3.24583 17.5002 4.16667 17.5002H15.8333C16.7542 17.5002 17.5 16.7543 17.5 15.8335V4.16683C17.5 3.246 16.7542 2.50016 15.8333 2.50016ZM10 2.50016C10.4583 2.50016 10.8333 2.871 10.8333 3.3335C10.8333 3.796 10.4583 4.16683 10 4.16683C9.54167 4.16683 9.16667 3.796 9.16667 3.3335C9.16667 2.871 9.54167 2.50016 10 2.50016ZM8.33333 14.1668L5 10.8335L6.17917 9.65433L8.33333 11.8085L13.8208 6.321L15 7.50016L8.33333 14.1668Z",
    fill: "#14AC63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_1111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractCreate);
export default __webpack_public_path__ + "static/media/ContractCreate.7afb734c3f1a496294920f1ed3075d96.svg";
export { ForwardRef as ReactComponent };